import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SingleValueWidget from './single-value-widget';
import TwyValueWidget from './twy-value-widget';

import TcWidget from './tc-widget';
import DashboardFilter from './dashboard-filters';

@inject('appStore')
@observer
export default class DashBoardAdminView extends Component {
    constructor(props) {
        super(props);
        this.dashboardFilter = new DashboardFilter();
    }

    render() {
        return (
            <div className="tab-pane active">
                <div className="row">
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <SingleValueWidget
                            label={'Total Pending Transactions'}
                            icon={'fa-home'}
                            filter={this.dashboardFilter.filters.PendingTransactions}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.totalPendingTransactions}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <SingleValueWidget
                            label={'Total Active Listings'}
                            icon={'fa-handshake-o'}
                            filter={this.dashboardFilter.filters.ActiveLisitings}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.totalActiveListings}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <TwyValueWidget
                            label={'Closed Files'}
                            icon={'fa-key'}
                            filterToday={this.dashboardFilter.filters.ClosedFileCountsToday}
                            filterWtd={this.dashboardFilter.filters.ClosedFileCountsWtd}
                            filterMtd={this.dashboardFilter.filters.ClosedFileCountsMtd}
                            filterYtd={this.dashboardFilter.filters.ClosedFileCountsYtd}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.closedFileCounts}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <TcWidget
                            label={'Pending Transactions per TC'}
                            filter={this.dashboardFilter.filters.PendingTransactions}
                            tcs={appStore.dashboardStore.pendingTransactionsPerTc}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <TcWidget
                            label={'Active Listings per TC'}
                            filter={this.dashboardFilter.filters.ActiveLisitings}
                            tcs={appStore.dashboardStore.activeListingsPerTc}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill">
                        <SingleValueWidget
                            label={'Total Pending Invoiced Files'}
                            icon={'fa-money'}
                            filter={this.dashboardFilter.filters.TotalPendingInvoicedFiles}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.totalPendingInvoicedFiles}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill ">
                        <TwyValueWidget
                            label={'New Transactions'}
                            icon={'fa-inbox'}
                            filterToday={this.dashboardFilter.filters.NewTransactionCountsToday}
                            filterWtd={this.dashboardFilter.filters.NewTransactionCountsWtd}
                            filterMtd={this.dashboardFilter.filters.NewTransactionCountsMtd}
                            filterYtd={this.dashboardFilter.filters.NewTransactionCountsYtd}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.newTransactionCounts}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-4 fill ">
                        <TwyValueWidget
                            label={'New Listings'}
                            icon={'fa-paper-plane'}
                            filterToday={this.dashboardFilter.filters.NewListingCountsToday}
                            filterWtd={this.dashboardFilter.filters.NewListingCountsWtd}
                            filterMtd={this.dashboardFilter.filters.NewListingCountsMtd}
                            filterYtd={this.dashboardFilter.filters.NewListingCountsYtd}
                            handleClick={this.props.handleClick}
                            value={appStore.dashboardStore.newListingCounts}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dashboard/dashboard-admin-view.js